module.exports = __webpack_public_path__ + "static/fan2-b52e4fe7797327d948edce889958d756.png";